// import { useContext, useState} from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";

let myAbilities = HelpAbility();

function ItemModalEmail({i, email: ema, vinculedEmail}) {
    const { documentClient, email, numeroReportes, /*_id*/ } = ema;

    const handleVinculedEmail = () => {
        vinculedEmail({email: ema});
    }
    return (
        <tr>
            <th className="text-center" scope="row">{i + 1}</th>
            <td className="text-center">{email}</td>
            <td className="text-center">{numeroReportes}</td>

            {myAbilities.hasAny([C.A.CUSTOMER.LINKEMAIL]) && <td className="text-center d-flex">
                {myAbilities.has(C.A.CUSTOMER.LINKEMAIL) &&

                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Vincular Correo</Tooltip>}>
                        <button type="button"
                            className="btn btn-sm btn-info me-2"
                            onClick={handleVinculedEmail}
                            disabled={documentClient ? true : false}
                            >
                            <i className="bi bi-person-fill" />
                        </button>
                    </OverlayTrigger>}

            </td>}
        </tr>
    )
}
export default ItemModalEmail